





























import { Component, Vue } from 'vue-property-decorator';
import EntityListPage from '@/views/shared/EntityListPage.vue';
import DxDateBox from 'devextreme-vue/date-box';

@Component({
  components: {
    EntityListPage,
    DxDateBox
  }
})
export default class CdrDettaglioPage extends Vue {
  constructor() {
    super();
  }
}
